import { useEffect } from 'react';

const useFocus = (refElem: React.RefObject<HTMLHeadingElement>): void => {
  useEffect(() => {
    if (refElem.current) {
      refElem.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useFocus;
